module.exports = __webpack_public_path__ + "static/media/cloud-icon.52753188.svg";